import React, { useEffect, useMemo, useState } from "react"
import PropTypes from "prop-types"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import {
  Card,
  CardBody,
  Form,
  Modal,
  ModalBody,
  Input,
  FormGroup,
  ModalHeader,
  Button,
  Label,
  FormFeedback,
  Row,
} from "reactstrap"
import * as Yup from "yup"
import { useFormik } from "formik"
import toast, { Toaster } from "react-hot-toast"
import useApi from "common/ApiMiddlewere"
import breadcrumbs from "../../common/Breadcrumbs"
import { useLocation } from "react-router-dom"
import SettingDataTable from "../Setting/SettingTable"
import axios from "axios"
import appConfig from "Api/app.config"

function SettingTable() {
  const { getApi, putApi } = useApi()
  document.title = `Settings | ${localStorage.getItem("ShopName")}`
  let { pathname } = useLocation()

  // useStates
  const [modal, setModal] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [editData, setEditData] = useState("")
  const [tableData, setTableData] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [settingId, setSettingId] = useState("")
  const [formSumitLoading, setformSumitLoading] = useState(false)

  // setting list api
  const settingApi = () => {
    setIsLoading(true)
    getApi(`api/Setting/list`).then(({ data, status }) => {
      if (status === 200) {
        setIsLoading(false)
        setTableData(data)
      } else {
        setIsLoading(false)
        toast.error(data, {
          style: {
            fontSize: "15px",
          },
        })
      }
    })
  }

  // setting list api useEffect
  useEffect(() => {
    settingApi()
  }, [])

  // handle cancel
  const handleCancle = () => {
    toggle()
  }

  // Update setting handler
  const handleEditSetting = settingData => {
    if (settingData) {
      setSettingId(settingData.id)
      setIsEdit(true)
      setModal(!modal)
      setEditData(settingData)
    }
  }

  // setting Validations
  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      value: isEdit ? editData?.value : "",
    },
    validationSchema: Yup.object({
      value: Yup.string().required("The Value is required"),
    }),
    onSubmit: values => {
      setformSumitLoading(true)
      if (values) {
        toggle()
        putApi("api/Setting/update", {
          id: settingId,
          value: values.value,
        }).then(({ data, status }) => {
          setformSumitLoading(false)
          if (status == 200) {
            toast.success("Sucessfully updated", {
              style: {
                fontSize: "15px",
              },
            })
            settingApi()
            validation.handleReset()
          } else {
            toast.error(data, {
              style: {
                fontSize: "15px",
              },
            })
            validation.handleReset()
          }
        })
      }
    },
  })

  // popup box handler
  const toggle = () => {
    setModal(!modal)
  }

  // table headers & accessor
  const columns = useMemo(
    () => [
      {
        Header: "Name",
        accessor: "displayName",
        width: "8%",
      },
      {
        Header: "Key",
        accessor: "key",
        width: "8%",
      },
      {
        Header: "Value",
        accessor: "value",
        Cell: ({ row }) => (
          <div className="text-wrap">
            {row.original.value}
          </div>
        ),
      },
      {
        Header: () => (
          <div
            style={{
              textAlign: "center",
            }}
          >
            Action
          </div>
        ),
        width: "7%",
        accessor: "action",
        disableFilters: true,
        Cell: ({ row }) => {
          return (
            <ul className="list-unstyled hstack gap-1 mb-0 d-flex justify-content-center gap-2">
              <li className="mytooltip">
                <i
                  className=" fs-6 fas fa-edit btn-edit"
                  id={`edittooltip${row.original.id}`}
                  onClick={() => handleEditSetting(row.original)}
                ></i>
                <span className="mytext">Edit</span>
              </li>
            </ul>
          )
        },
      },
    ],
    [tableData]
  )

  return (
    <div className="page-content">
      <div className="container-fluid">
        {isLoading && (
          <div className="loading-overlay is-active">
            <span className="fas fa-spinner fa-3x fa-spin"></span>
          </div>
        )}
        <Breadcrumbs
          title={breadcrumbs[pathname].title}
          breadcrumbItem={breadcrumbs[pathname].breadcrumbItem}
        />
        <Card>
          <CardBody>
            <SettingDataTable
              columns={columns}
              data={tableData}
              isGlobalFilter={true}
              customPageSize={10}
              isLoading={isLoading}
              className="custom-header-css"
            />

            <Modal
              isOpen={modal}
              toggle={toggle}
              centered={true}
              size="small"
              style={{ width: "550px" }}
            >
              <div className="modal-content">
                <ModalHeader toggle={toggle} tag="h5">
                  {"Update Setting"}
                </ModalHeader>
                <ModalBody>
                  <Form
                    onSubmit={e => {
                      e.preventDefault()
                      validation.handleSubmit()
                      return false
                    }}
                    onReset={e => {
                      e.preventDefault
                      validation.handleReset()
                      return false
                    }}
                  >
                    <Row>
                      <FormGroup className="mb-2">
                        <Label htmlFor="validationCustom03">
                          {editData.displayName}
                        </Label>
                        <Input
                          name="value"
                          placeholder=""
                          type="textarea"
                          rows="3"
                          className="form-control-sm"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.value || ""}
                          invalid={
                            validation.touched.value && validation.errors.value
                              ? true
                              : false
                          }
                        />
                        {validation.touched.value && validation.errors.value ? (
                          <FormFeedback type="invalid">
                            {validation.errors.value}
                          </FormFeedback>
                        ) : null}
                      </FormGroup>
                    </Row>
                    <div className="text-end">
                      <Button
                        color="secondary"
                        className="btn btn-primary me-2 btn-sm "
                        onClick={handleCancle}
                      >
                        Cancle
                      </Button>
                      {formSumitLoading ? (
                        <button
                          type="button"
                          className="btn btn-primary btn-sm"
                        >
                          <i className="bx bx-hourglass bx-spin font-size-16 align-middle me-2"></i>
                          Loading
                        </button>
                      ) : (
                        <Button
                          color="primary"
                          className="btn btn-primary btn-sm "
                          type="submit"
                        >
                          Submit
                        </Button>
                      )}
                    </div>
                  </Form>
                </ModalBody>
              </div>
            </Modal>
          </CardBody>
        </Card>
      </div>
    </div>
  )
}

SettingTable.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
}

export default SettingTable
